import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { COMMON_ERROR } from 'utils/ErrorMessages'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import { DATA_UPDATE_ASYNC } from './Editor/constants'
import editorEpics from './Editor/epics'
import logoEpics from './Logo/epics'
import {
  deleteLocaleError,
  deleteLocaleSuccess,
  fetchDataError,
  fetchDataSuccess,
  fetchLocaleError,
  fetchLocaleSuccess,
} from './actions'
import {
  ADD_LANGUAGE,
  ANNOUNCEMENT_SELECT,
  DATA_REQUEST_ASYNC,
  LOCALE_DELETE_ASYNC,
  LOCALE_REQUEST_ASYNC,
} from './constants'

const fetchDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DATA_REQUEST_ASYNC.INITIATE,
      LOCALE_DELETE_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.endUserAlerts)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getAnnouncements(
          store.getState().partnerOptions.selectedCompany?.value,
          store.getState().partnerOptions.selectedCompany?.value || store.getState().app.data.id
        )
        .map((response) => fetchDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error)))
        .takeUntil(action$.ofType(DATA_REQUEST_ASYNC.CANCEL))
    )

const fetchLocaleEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      LOCALE_REQUEST_ASYNC.INITIATE,
      ANNOUNCEMENT_SELECT,
      LOCALE_DELETE_ASYNC.SUCCESS,
      DATA_UPDATE_ASYNC.SUCCESS,
      ADD_LANGUAGE
    )
    .mergeMap((action) => {
      const activeId = store.getState().settings.notifications.enduser.data.activeIndex
      const announcementId = store.getState().settings.notifications.enduser.data.items[activeId].id
      const announcementTrigger =
        store.getState().settings.notifications.enduser.data.items[activeId].trigger

      const localeId = store.getState().settings.notifications.enduser.data.locale.locale_id

      const isGroupSettings = matchURL(URL_CONST.groupSettings.wizard)
      return api.settings
        .getAnnouncementLocale(
          store.getState().partnerOptions.selectedCompany?.value,
          announcementId,
          localeId,
          announcementTrigger,
          isGroupSettings
        )
        .map((response) => fetchLocaleSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchLocaleError, error)))
    })
    .takeUntil(action$.ofType(LOCALE_REQUEST_ASYNC.CANCEL))

const deleteDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(LOCALE_DELETE_ASYNC.INITIATE).mergeMap((action) =>
    api.settings
      .deleteAnnouncementLocale(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.data
      )
      .mergeMap(() =>
        Observable.of(deleteLocaleSuccess(action.payload.data), addToast({ message: 'Deleted!' }))
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(deleteLocaleError, error),
          addToast({
            type: 'error',
            message: error.status === 400 ? "Default Notification can't be removed." : COMMON_ERROR,
          })
        )
      )
      .takeUntil(action$.ofType(LOCALE_DELETE_ASYNC.CANCEL))
  )

export default combineEpics(
  editorEpics,
  logoEpics,

  fetchDataEpic,
  fetchLocaleEpic,
  deleteDataEpic
)
